import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { wait } from '../utils/asyncUtil';

const RETRY_TIMEOUT = 3000;
const MAX_RETRIES = (3 * 60 * 1000) / RETRY_TIMEOUT;

export function useAwaitQuoteJob(): {
    awaitQuoteJob: () => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const awaitQuoteJob = async (): Promise<void> => {
        let retries = 0;
        const response = await OnlineSales.getJobStatus(jobNumber, sessionId);
        let status = response.status;

        while (status !== 'Quoted' && retries < MAX_RETRIES) {
            switch (status) {
                case 'Quoting': {
                    await wait(RETRY_TIMEOUT);
                    const retryResponse = await OnlineSales.getJobStatus(jobNumber, sessionId);
                    status = retryResponse.status;
                    break;
                }
                default:
                    throw new Error(`Returned unexpected status of ${status ?? ''}.`);
            }
            retries += 1;
        }
        if (retries === MAX_RETRIES) throw new Error('Exceeded max retries for awaitQuoteJob.');
    };

    return { awaitQuoteJob };
}
